<template>
  <div>
    <div class="frm">
      <div>
        <v-text-field
          v-model="user_name"
          label="Name"
          :error-messages="nameErrors"
          solo
          outline>
        </v-text-field>
      </div>
      <div>
        <v-text-field
          @keydown.space.prevent
          v-model="email"
          @input="email=removeWhiteSpace($event)"
          label="Email"
          :error-messages="emailErrors"
          solo
          outline>
        </v-text-field>
      </div>
      <div>
        <v-select
          v-model="admin_permissions"
          :items="actions"
          solo
          outline
          chips
          label="Permissions"
          multiple
          item-text="name"
          item-value="value"
          :error-messages="permErrors">
        </v-select>
      </div>
      <div class="row text-left">
        <button @click="createAdmin" class="btn btn-save">Save</button>
        <button @click="closeForm" style="margin-left: 1rem" class="btn btn-prv-outline">Cancel</button>
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right: 1rem"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
    import {
        required,
        minLength,
        maxLength,
        email,
    } from "vuelidate/lib/validators";
    import {IsEmptyObject} from "../../../globalFunctions";
    import {CRETAE_ADMIN} from "../../../Api/admin_api";
    export default {
        name: "adminAdd",
        validations: {
            user_name: {
                required,
                minLength: minLength(4),
                maxLength: maxLength(64)
            },
            email: {
                required,
                email,
                minLength: minLength(4),
                maxLength: maxLength(64)
            },
            admin_permissions: {
                required
            }
        },
        props: {
            adminActions: Object
        },
        data: function () {
            return {
                timeOut: 1000,
                bgColor: "#454545",
                snackbar: false,
                snackMessage: "",
                snackIcon: "",
                user_name: '',
                email: '',
                admin_permissions: [],
                actions: []
            }
        },
        methods: {
            removeWhiteSpace(text) {
                return text.replace(/[\s\/]/g, "");
            },
            createAdmin(){
                const self = this;
                self.$v.$touch();
                if (!self.$v.$anyError) {
                    let data = {
                        user_name: self.user_name,
                        email: self.email,
                        admin_permissions: self.admin_permissions
                    };
                    CRETAE_ADMIN(data).then(function (response) {
                        self.edit = false;
                        self.$emit('close-form',response.message)
                    }).catch(function (error) {
                        self.snackbar = true;
                        self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
                        self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
                        self.snackMessage = error.response.data.title;
                    })
                }
            },
            closeForm(){
                this.$emit('close-form')
            }
        },
        computed: {
            nameErrors() {
                const errors = [];
                if (!this.$v.user_name.$dirty) return errors;
                !this.$v.user_name.minLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.NAME);
                !this.$v.user_name.maxLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.NAME);
                !this.$v.user_name.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                return errors;
            },
            emailErrors() {
                const errors = [];
                if (!this.$v.email.$dirty) return errors;
                !this.$v.email.email &&
                errors.push(this.$constants.REQUIRED_MESSAGE.EMAIL_INVALID);
                !this.$v.email.minLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.EMAIL_INVALID);
                !this.$v.email.maxLength &&
                errors.push(this.$constants.REQUIRED_MESSAGE.EMAIL_INVALID);
                !this.$v.email.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                return errors;
            },
            permErrors(){
                const errors = [];
                if (!this.$v.admin_permissions.$dirty) return errors;
                !this.$v.admin_permissions.required &&
                errors.push(this.$constants.REQUIRED_MESSAGE.REQUIRED);
                return errors;
            }
        },
        mounted() {
            const self = this;
            if(!IsEmptyObject(self.adminActions)) {
                for(let key in self.adminActions) {
                    let obj = {
                        name: key,
                        value: self.adminActions[key]
                    };
                    self.actions.push(obj)
                }
            }
        }
    }
</script>

<style scoped>
.frm{
  max-width: 60rem;
  margin: 4rem 2rem;
}
</style>